import React from 'react';
import { Typography, useTheme } from '@mui/material';

interface HighlightedTextProps {
  text: string;
  searchTerm: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  searchTerm,
}) => {
  const theme = useTheme();

  if (!searchTerm) {
    return <Typography component="span">{text}</Typography>;
  }

  const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));

  return (
    <Typography component="span">
      {parts.map((part, index) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? (
          <mark
            key={index}
            style={{
              backgroundColor: theme.palette.warning.light,
              color: theme.palette.warning.contrastText,
              borderRadius: '4px',
            }}
          >
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </Typography>
  );
};

export default HighlightedText;
